export default function sponsorService($http, RESOURCES, OC_API) {
  function getSponsors(startDate, endDate, destinationId) {
    return $http.get(RESOURCES.SPONSORS, {
      params: {
        startDate: moment(startDate).format(OC_API.DATE_FORMAT),
        endDate: moment(endDate).format(OC_API.DATE_FORMAT),
        destinationId: destinationId,
      },
    });
  }

  function getSponsorsById(sponsorIds) {
    return $http.get(RESOURCES.SPONSORS, {
      params: {
        ids: sponsorIds,
      },
    });
  }

  function getSponsorsAvailability(startDate, endDate, destinationId, sponsorType) {
    return $http.get(RESOURCES.SPONSORS + '/availability', {
      params: {
        startDate: moment(startDate).format(OC_API.DATE_FORMAT),
        endDate: moment(endDate).format(OC_API.DATE_FORMAT),
        destinationId: destinationId,
        sponsorType: sponsorType,
      },
    });
  }

  function updateSponsor(data) {
    return $http.put(RESOURCES.SPONSORS, data);
  }

  function deleteSponsor(sponsorId) {
    return $http.delete(RESOURCES.SPONSORS + '/' + sponsorId);
  }

  return {
    getSponsors: getSponsors,
    getSponsorsById: getSponsorsById,
    updateSponsor: updateSponsor,
    deleteSponsor: deleteSponsor,
    getSponsorsAvailability: getSponsorsAvailability,
  };
}



// WEBPACK FOOTER //
// ./src/app/sponsors/sponsor.service.js